export default {
  name: 'pagination',

  props: {
    value: { type: Number, required: true},
    steps: { type: Number, required: true},
    disabledSteps: { type: Array, default: () => [] },
  },

  data () {
    return {
      current: this.value
    }
  },

  watch: {
    value (val) {
      this.current = val
    },

    current (val) {
      this.$emit('input', val)
    }
  },
}
